import React from 'react';
import classNames from 'classnames';
import { Checkbox } from '~/components/atoms/checkbox/Checkbox';
import { IndexFilters_ControlsState, IndexFilters_State } from '~/core/features/indexFiltering/types/indices.type';
import { UpdateIndexFilterControls } from '~/core/useSearchState';
import styles from './indicesFilter.module.scss';

export interface IndicesFilterProps {
    indicesControls: IndexFilters_ControlsState;
    indicesState: IndexFilters_State;
    querySetIdentifier: string;
    updateIndexFilterControls: UpdateIndexFilterControls;
}

const IndicesFilter: React.FC<IndicesFilterProps> = ({
    indicesControls,
    indicesState,
    querySetIdentifier,
    updateIndexFilterControls,
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateIndexFilterControls({ querySetIdentifier, indexIdentifier: e.target.id, check: e.target.checked });
    };

    return (
        <div className={classNames(styles.indices, 'serp-indices')} data-testid="indices-filter">
            {indicesState.map((index, i) => {
                const indexControlsState = indicesControls.find((control) => control.identifier === index.identifier);
                if (!indexControlsState) {
                    throw new Error(`Index ${index.identifier} not found in indexControls`);
                }
                return (
                    <Checkbox
                        key={i}
                        name={index.name}
                        id={index.identifier}
                        label={index.name}
                        handleChange={handleChange}
                        className={styles.indicesCheckbox}
                        renderChecked={indexControlsState.isChecked}
                    />
                );
            })}
        </div>
    );
};

export default IndicesFilter;
